import Button from "../ui/Button";

const COLOR_TO_VARIANT = {
  purple: "secondary",
  blue: "soft",
  red: "danger",
  green: "success",
};

export default function ActionButton({
  color = "purple",
  children,
  className = "",
  loading = false,
  disabled = false,
  ...props
}) {
  return (
    <Button
      variant={COLOR_TO_VARIANT[color] || "secondary"}
      size="sm"
      className={`min-w-[74px] ${className}`.trim()}
      loading={loading}
      disabled={disabled}
      {...props}
    >
      {children}
    </Button>
  );
}
